import type { CropVarietyConfigurationsByKey } from "../types.js";

export const cherryVarietyConfigurations = {
    "cherry.0900-ziraat": {
        crop: "cherry",
        aliases: ["Ziraat"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.benton": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.bing": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.black-pearl": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.black-republican": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.black-tartarian": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.brooks": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.burlat": {
        crop: "cherry",
        aliases: ["Early Burlat", "Bigarreau Burlat"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.celeste": {
        crop: "cherry",
        aliases: ["Sumpaca", "13S-24-28"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.chelan": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.coral-champagne": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.cowiche": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.cristalina": {
        crop: "cherry",
        aliases: ["Sumnue", "2C-61-22"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.early-robin": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.hedelfingen": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.kordia": {
        crop: "cherry",
        aliases: ["Attika"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.lambert": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.lapins": { crop: "cherry", aliases: [], isExample: true, customName: false, knownClonalSelections: [] },
    "cherry.minnie-royal": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.montmorency": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.rainier": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.regina": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.royal-ann": {
        crop: "cherry",
        aliases: ["Napoleon", "Royal Anne"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.royal-bailey": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.royal-crimson": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.royal-dawn": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.royal-hazel": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.royal-lee": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.samba": {
        crop: "cherry",
        aliases: ["Sumste", "13S-36-18"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.sandra-rose": {
        crop: "cherry",
        aliases: ["13S-10-40"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.santina": {
        crop: "cherry",
        aliases: ["13S-5-22"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.selah": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.sentennial": {
        crop: "cherry",
        aliases: ["SPC103"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.skeena": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.skylar-rae": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.sonata": {
        crop: "cherry",
        aliases: ["Sumleta", "13N-6-59"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.staccato": {
        crop: "cherry",
        aliases: ["13S-20-09"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.stella": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.sweetheart": {
        crop: "cherry",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "cherry.symphony": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.tieton": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.tulare": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.van": { crop: "cherry", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "cherry.custom": { crop: "cherry", aliases: [], isExample: false, customName: true, knownClonalSelections: [] },
} as const satisfies CropVarietyConfigurationsByKey;
